import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
class CookiesSettings {
	constructor() {
		this.cookieDomain = location.hostname;
		// three months Duration?
		this.cookieDuration = 90;
		this.Cookies = undefined;

		this.cookiesForm = SelectorEngine.findOne('#lta-cookies-settings-form');
		this.cookiesMessage = SelectorEngine.findOne('.lta-cookies-message');

		// third party cookies disabling for LTA play mobile
		this.thirpartyCookiesWrapper = SelectorEngine.findOne('.thirdPartyCookies');
		const isLTAPLAYMOBILE = document.querySelector('body').getAttribute('data-is-LTAPLAYMOBILE');
		this.isLTAPLAYMOBILE = isLTAPLAYMOBILE === 'True' || isLTAPLAYMOBILE === 'true';
		const thirdPartyCookiesAttribute = document.querySelector('body').getAttribute('data-is-ThirdPartyCookiesDisabled');
		this.disabledThirdPartyCookies = thirdPartyCookiesAttribute === 'True' || thirdPartyCookiesAttribute === 'true';

		if (this.cookiesForm) {
			// eslint-disable-next-line promise/catch-or-return
			this.initCookiesLib().then(() => this.initEvents());
		}
	}

	initCookiesLib() {
		return import('js-cookie')
			.then(({ default: Cookies }) => {
				this.Cookies = Cookies;
				return this.Cookies;
			})
			.catch((error) => {
				console.log(error);
			});
	}

	setCookie(type, value, cookie = {func:true, perf: true, trgt: true, thrd: true}) {
		this.Cookies.set(type, value, { domain: this.cookieDomain, expires: this.cookieDuration });

		try {
			// More data send, for the GTM events to handle
			window.dataLayer.push({
				event: 'cookie-consent',
				funcCategory: cookie.func,
				perfCategory: cookie.perf,
				trgtCategory: cookie.trgt,
				thrdCategory: cookie.thrd,
				clicked: "Change cookie setiings"
			});
		} catch (e) {
			console.log(e.message);
		}
	}

	initEvents() {
		// third party cookies disabling for LTA play mobile
		if (this.disabledThirdPartyCookies && this.isLTAPLAYMOBILE) {
			this.thirpartyCookiesWrapper.classList.add('u-hidden');
		} else {
			this.thirpartyCookiesWrapper.classList.remove('u-hidden');
		}

		// Apply current cookies settings on the form
		if (this.Cookies.get('cookieprefs')) {
			const currentCookie = JSON.parse(this.Cookies.get('cookieprefs'));

			const setRadio = function (radio) {
				if (radio) radio.setAttribute('checked', 'true');
			};

			// Find current value for each cookie category and then update form
			let radio;
			if (currentCookie.func) {
				radio = SelectorEngine.findOne('#accept-func');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-func');
				setRadio(radio);
			}
			if (currentCookie.perf) {
				radio = SelectorEngine.findOne('#accept-perf');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-perf');
				setRadio(radio);
			}
			if (currentCookie.trgt) {
				radio = SelectorEngine.findOne('#accept-trgt');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-trgt');
				setRadio(radio);
			}
			if (currentCookie.thrd) {
				radio = SelectorEngine.findOne('#accept-thrd');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-thrd');
				setRadio(radio);
			}
		} else {
			// Default values rejected all

			const rejectedInputs = SelectorEngine.find('#decline-func, #decline-perf, #decline-trgt, #decline-thrd');
			for (const radioInput of rejectedInputs) {
				radioInput.setAttribute('checked', true);
			}
		}

		// Cookies Form Submit Event
		// Check for accepted cookies categories and display success Message
		EventHandler.on(this.cookiesForm, 'submit', (event) => {
			event.preventDefault();
			const formData = new FormData(this.cookiesForm);

			if (formData) {
				const newCookie = {
					func: formData.get('func') === 'true',
					perf: formData.get('perf') === 'true',
					trgt: formData.get('trgt') === 'true',
					// third party cookies disabling for LTA play mobile
					thrd:
						this.disabledThirdPartyCookies && this.isLTAPLAYMOBILE ? false : formData.get('thrd') === 'true'
				};

				this.setCookie('cookieprefs', JSON.stringify(newCookie));

				// If one of the categories is set to false consent = false
				if (!newCookie.func || !newCookie.perf || !newCookie.trgt) {
					this.setCookie('consent', false, newCookie);
				} else {
					this.setCookie('consent', true);
				}

				window.scrollTo(0, 0);
				this.cookiesMessage.classList.add('is-visible');

				// Remove class to restart animation on change
				EventHandler.one(this.cookiesMessage, 'animationend', (cookieMessageEvent) => {
					cookieMessageEvent.target.classList.remove('is-visible');
				});
			}
		});
		return 1;
	}
}

const globalCookiesSettings = new CookiesSettings();
export default globalCookiesSettings;
